const useCareersHook = () => {

  const getData = async () => {
    const leverApiUrl = 'https://api.lever.co/v0/postings/buckmason?group=team&mode=json'
    const data = await fetch(leverApiUrl)
    const json = await data.json()

    if (!json || json.length < 1) return {corp: [], retail: []}

    let retail = json.find(x => x.title === 'Retail')
    let fasttimes = json.find(x => x.title === 'Fast Times')
    let corp = json.filter(x => x.title !== 'Retail' && x.title !== 'Fast Times')
    if (corp) corp = handleCorp(corp)
    if (retail) {
      if (fasttimes) retail.postings = retail.postings.concat(fasttimes.postings)
      retail = handleRetail(retail)
    }

    return {corp: corp, retail: retail}
  }

  const handleCorp = (data) => {
    data.forEach(cat => {
      cat.title = nullCheck(cat.title).replace('&', '+').replace(' and ', ' + ')

      const regions = [...new Set( cat.postings.map(x => x.categories.location) )].sort()
      cat.regions = compactRegions(regions)

    })

    return data
  }

  const handleRetail = (data) => {
    let retail = {}

    data.postings.forEach(job => {
      let loc = checkLoc(job.categories.location)
      retail[loc] = retail[loc] || []
      retail[loc].push(job)
    })

    retail = Object.keys(retail).sort().map(region => ({
      title: region, 
      postings: retail[region].sort((a, b) => a.text.localeCompare(b.text))
    }))

    retail = retail.reduce((result, item, index) => {
      const chunkIndex = Math.floor(index / 8);
      if (!result[chunkIndex]) {
        result[chunkIndex] = [];
      }
      result[chunkIndex].push(item);
      return result;
    }, [])
    return retail
  }

  const nullCheck = (str) => {
    return !str ? 'Uncategorized' : str
  }

  const checkLoc = (str) => {
    let ny_strs = [', NY', ', Brooklyn'];
    let la_strs = ['Los Angeles', 'Palisades,', 'Studio City,', 'Venice', 'Buck Mason HQ', 'Hancock Park']

    let loc = str
    if ( loc.includes(', San Francisco') ) loc = 'San Francisco, CA'
    if ( loc.includes('Chicago') ) loc = 'Chicago, IL'
    if ( loc.includes('D.C.') || loc.includes('Tysons Corner') ) loc = 'D.C. Area'
    if ( loc.includes(', South Carolina') ) loc = loc.replace(', South Carolina', ', SC')
    if ( la_strs.find(x => str.includes(x)) ) loc = 'Los Angeles, CA'
    if ( ny_strs.find(x => str.includes(x)) ) loc = 'New York, NY'
    return loc
  }

  const compactRegions = (arr) => {
    let new_arr = arr.map(str => checkLoc(str))
    new_arr = [...new Set( new_arr )].sort()
    return new_arr
  }

  return { getData }

};

export default useCareersHook

